  
  // content slider//

function initContentSlider(slider) {
  if (!slider) return;
  if (slider.classList.contains('splide--content-initialized')) return;

  const splide = new Splide(slider, {
    type: 'loop',
    perPage: 3,
    perMove: 1,
    gap: '20px',
    pagination: false,
    arrows: true,
    drag: true,
    breakpoints: {
      1024: { perPage: 2 },
      768: { perPage: 2 },
      575: {
        perPage: 1,
        perMove: 1,
        padding: { right: '0px', left: '0px' }
      },
    },
  });

  splide.mount();
  slider.classList.add('splide--content-initialized');
}

function autoinitContentSliders(scope = document) {
  scope.querySelectorAll('.content-splide').forEach((slider) => {
    initContentSlider(slider);
  });
}

document.addEventListener('DOMContentLoaded', () => autoinitContentSliders());
document.addEventListener('shopify:section:load', (event) =>
  autoinitContentSliders(event.target)
);
document.addEventListener('shopify:section:select', (event) =>
  autoinitContentSliders(event.target)
);
  
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.scroll-down-arrow');
  if (!btn) return;

  e.preventDefault();

  const target =
    document.querySelector('.image-with-content-sec') ||
    document.querySelector('.video-with-content');

  if (!target) return;

  const header = document.querySelector('.header');
  const headerHeight = header ? header.offsetHeight : 0;

  const rect = target.getBoundingClientRect();
  const scrollTop = window.pageYOffset;

  const targetPosition = rect.top + scrollTop;

  let offsetPosition;

   if (window.innerWidth <= 768) {
    offsetPosition = targetPosition - headerHeight + 33;
  } else {
    
    if (window.location.pathname === '/') {
      offsetPosition = targetPosition - headerHeight + 80;
    } else {
      offsetPosition = targetPosition - headerHeight;
    }
  }

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth'
  });
    setTimeout(() => {
    target.classList.add('active-scroll');

    const removeOnScroll = () => {
      target.classList.remove('active-scroll');
      window.removeEventListener('scroll', removeOnScroll);
    };

    window.addEventListener('scroll', removeOnScroll);
  }, 700); 
});

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.wn-scroll-down-arrow');

  if (!btn) return;

  e.preventDefault();

  // Get target ID from href
  const targetId = btn.getAttribute('href');

  if (!targetId) return;

  const target = document.querySelector(targetId);

  if (!target) return;

  const header = document.querySelector('.header');
  const headerHeight = header ? header.offsetHeight : 0;

  const rect = target.getBoundingClientRect();
  const scrollTop = window.pageYOffset;

  const targetPosition = rect.top + scrollTop;

  let offsetPosition;

  if (window.innerWidth <= 768) {
    offsetPosition = targetPosition - headerHeight + 33;
  } else {

    if (window.location.pathname === '/') {
      offsetPosition = targetPosition - headerHeight + 80;
    } else {
      offsetPosition = targetPosition - headerHeight;
    }
  }

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth'
  });

  setTimeout(() => {
    target.classList.add('active-scroll');

    const removeOnScroll = () => {
      target.classList.remove('active-scroll');
      window.removeEventListener('scroll', removeOnScroll);
    };

    window.addEventListener('scroll', removeOnScroll);
  }, 700);
});


// document.addEventListener('click', function(e) {
//   const btn = e.target.closest('.scroll-down-arrow');
//   if (!btn) return;

//   e.preventDefault();

//   const target = btn.getAttribute('href');
//   const section = document.querySelector(target) || 
//                   document.querySelector(`#shopify-section-${target.replace('#','')}`);

//   if (!section) return;

//   const headerHeight = document.querySelector('header')?.offsetHeight || 0;
//   const extraOffset = 50;
//   const sectionPosition = section.offsetTop - headerHeight - extraOffset;

//   window.scrollTo({
//     top: sectionPosition,
//     behavior: 'smooth'
//   });


//   setTimeout(() => {
//     section.classList.add('active-scroll');

//     const removeOnScroll = () => {
//       section.classList.remove('active-scroll');
//       window.removeEventListener('scroll', removeOnScroll);
//     };

//     window.addEventListener('scroll', removeOnScroll);
//   }, 700); 
// });
  
// document.querySelectorAll('.scroll-down-arrow').forEach(function(btn){
//   btn.addEventListener('click', function(e){
//     e.preventDefault();

//     const target = this.getAttribute('href');
//     const section = document.querySelector(target);

//     if(section){

//       const headerHeight = document.querySelector('header').offsetHeight;
//       const extraOffset = 50;
//       const sectionPosition = section.offsetTop - headerHeight - extraOffset;

//       window.scrollTo({
//         top: sectionPosition,
//         behavior: 'smooth'
//       });

//     }
//   });
// });

document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll('a[href]').forEach(function(link) {

    // scroll arrow skip
    if(link.classList.contains('scroll-down-arrow')) return;
     if (link.getAttribute('target') === '_blank') return;

    link.addEventListener('click', function(e) {

      const url = this.getAttribute('href');

      if(url && url !== '#' && !url.startsWith('javascript') && !url.startsWith('#')){

        e.preventDefault();

        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });

        setTimeout(function(){
          window.location.href = url;
        }, 500);

      }

    });

  });

  document.querySelectorAll('.play_video_button').forEach(function(play_btn) {

    play_btn.addEventListener('click', function(e) {

      e.preventDefault();

      const wrapper = e.currentTarget.closest('.text-image-video-item');

      const iframe = wrapper.querySelector('iframe');

      // Make sure enablejsapi=1 exists
      if (!iframe.src.includes('enablejsapi=1')) {

        const separator = iframe.src.includes('?') ? '&' : '?';

        iframe.src = iframe.src + separator + 'enablejsapi=1';

      }

      // Play video
      iframe.contentWindow.postMessage(
        JSON.stringify({
          event: 'command',
          func: 'playVideo',
          args: []
        }),
        '*'
      );

    });

  });
});


// me and you sec video//

// document.addEventListener('DOMContentLoaded', function () {

//   const wrapper = document.querySelector('.video-wrapper');
//   const video = document.querySelector('.custom-video');
//   const btn = document.querySelector('.video-toggle');
//   const thumbnail = document.querySelector('.video-thumbnail');

//   const playIcon = btn.querySelector('.play-icon');
//   const pauseIcon = btn.querySelector('.pause-icon');
//   const replayIcon = btn.querySelector('.replay-icon');

//   btn.addEventListener('click', function () {

//     if (thumbnail) {
//       thumbnail.style.display = 'none';
//     }

//     if (video.ended) {

//       video.currentTime = 0;
//       video.play();

//       wrapper.classList.add('playing');
//       wrapper.classList.remove('ended');

//       replayIcon.style.display = 'none';
//       pauseIcon.style.display = 'inline';
//       playIcon.style.display = 'none';

//     } 
//     else if (video.paused) {

//       video.play();

//       wrapper.classList.add('playing');

//       playIcon.style.display = 'none';
//       pauseIcon.style.display = 'inline';

//     } 
//     else {

//       video.pause();

//       wrapper.classList.remove('playing');

//       pauseIcon.style.display = 'none';
//       playIcon.style.display = 'inline';

//     }

//   });

//   video.addEventListener('ended', function () {

//     wrapper.classList.remove('playing');
//     wrapper.classList.add('ended');

//     playIcon.style.display = 'none';
//     pauseIcon.style.display = 'none';
//     replayIcon.style.display = 'inline';

//   });

// });

document.addEventListener('DOMContentLoaded', function () {

  const wrapper = document.querySelector('.video-wrapper');
  const video = document.querySelector('.custom-video');
  const btn = document.querySelector('.video-toggle');
  const thumbnail = document.querySelector('.video-thumbnail');

  const playIcon = btn.querySelector('.play-icon');
  const pauseIcon = btn.querySelector('.pause-icon');
  const replayIcon = btn.querySelector('.replay-icon');

  
  const isMobile = 'ontouchstart' in window || window.innerWidth <= 768;

  btn.addEventListener('click', function () {

    if (thumbnail) {
      thumbnail.style.display = 'none';
    }

    if (video.ended) {

      video.currentTime = 0;
      video.play();

      wrapper.classList.add('playing');
      wrapper.classList.remove('ended');

      replayIcon.style.display = 'none';
      pauseIcon.style.display = 'inline';
      playIcon.style.display = 'none';

      
      if (isMobile) {
        btn.style.opacity = '0';
      }

    } 
    else if (video.paused) {

      video.play();

      wrapper.classList.add('playing');

      playIcon.style.display = 'none';
      pauseIcon.style.display = 'inline';

      
      if (isMobile) {
        btn.style.opacity = '0';
      }

    } 
    else {

      video.pause();

      wrapper.classList.remove('playing');

      pauseIcon.style.display = 'none';
      playIcon.style.display = 'inline';

      
      if (isMobile) {
        btn.style.opacity = '1';
      }

    }

  });

  video.addEventListener('ended', function () {

    wrapper.classList.remove('playing');
    wrapper.classList.add('ended');

    playIcon.style.display = 'none';
    pauseIcon.style.display = 'none';
    replayIcon.style.display = 'inline';

    
    if (isMobile) {
      btn.style.opacity = '1';
    }

  });

});
// card slider//

function initCardSlider(slider) {
  if (!slider) return;
  if (slider.classList.contains('splide--card-initialized')) return;

  const splide = new Splide(slider, {
    type: 'loop',
    perPage: 2,
    perMove: 1,
    gap: '118px',
    pagination: false,
    arrows: true,
    drag: true,
    breakpoints: {
      1024: { perPage: 2 },
      575: {
        perPage: 1,
        perMove: 1,
        padding: { right: '0px', left: '0px' }
      },
    },
  });

  splide.mount();
  slider.classList.add('splide--card-initialized');
}

function autoInitCardSliders(scope = document) {
  scope.querySelectorAll('.card-splide').forEach((slider) => {
    initCardSlider(slider);
  });
}


document.addEventListener('DOMContentLoaded', () => autoInitCardSliders());


document.addEventListener('shopify:section:load', (event) =>
  autoInitCardSliders(event.target)
);


document.addEventListener('shopify:section:select', (event) =>
  autoInitCardSliders(event.target)
);

// Get Header Height

const header = document.querySelector("header.header");

function updateHeaderHeight() {
  if (!header) return;

  const height = header.getBoundingClientRect().height;
  document.documentElement.style.setProperty("--header-height", `${height}px`);
}

// Run after DOM is ready
window.addEventListener("DOMContentLoaded", () => {
  requestAnimationFrame(updateHeaderHeight);
});

// Run after full load (images, fonts)
window.addEventListener("load", () => {
  setTimeout(updateHeaderHeight, 50);
});

// Run on resize
window.addEventListener("resize", () => {
  requestAnimationFrame(updateHeaderHeight);
});

// Observe dynamic size changes
const observer = new ResizeObserver(() => {
  requestAnimationFrame(updateHeaderHeight);
});

if (header) observer.observe(header);



// Menu Icon animation
const btns = document.querySelectorAll('.header__icon--menu');

btns.forEach(btn => {
  btn.addEventListener('click', function () {
    this.classList.toggle('active');
    this.classList.toggle('not-active');
  });
});


document.addEventListener('DOMContentLoaded', function () {
  document.body.classList.add('banner-dim');

  function removeOpacity() {
    document.body.classList.remove('banner-dim');
    window.removeEventListener('scroll', removeOpacity);
  }

  window.addEventListener('scroll', removeOpacity, { once: true });
});